import service from '@/utils/axios-v2'

export function getDialerCondition() {
  return service({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: '/loadboard/check/dialer-condition',
    method: "get",
    headers: {
      "portal-token": true,
      "system-source": 'fleet'
    }
  });
}